import { Avatar, Menu, MenuItem, Link as AccountLink } from '@mui/material'
import i18n from 'i18next'
import React, { useState } from 'react'
import { Cookies } from 'react-cookie'
import { icons } from '../../../../assets'
import { getLangLink, getMediaUrl } from '../../../../helpers'
import {useDefaultComponentTools} from '../../../../hooks/useDefaultComponentTools'


export default function Account() {
	const { t } = useDefaultComponentTools()
	const [anchorEl, setAnchorEl] = useState(null)
	const open = Boolean(anchorEl)
	const cookies = new Cookies()
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleCloseMenu = () => {
		setAnchorEl(null)
	}
	const onLogOut = () => {
		cookies.remove('oauth_access_token', { path: '/' })
	}

	return (
		<div>
			<Avatar
				sx={{':hover': {cursor: 'pointer'}}}
				id='basic-button'
				aria-controls={open ? 'basic-menu' : undefined}
				aria-haspopup='true'
				aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
				src={getMediaUrl() + icons['defaultAva']}
				alt='defaultAva'
			>
			</Avatar>
			<Menu
				id='basic-menu'
				anchorEl={anchorEl}
				open={open}
				onClose={handleCloseMenu}
				MenuListProps={{
					'aria-labelledby': 'basic-button'
				}}
			>
				<MenuItem
					href={getLangLink('/my-profile/', i18n.language.toLowerCase())}
					component={AccountLink} >{t('My Account')}
				</MenuItem>
				<MenuItem
					href={getLangLink('/exchange/', i18n.language.toLowerCase())}
					component={AccountLink}>{t('Exchange')}
				</MenuItem>
				<MenuItem
					href={getLangLink('/deposit-funds/', i18n.language.toLowerCase())}
					component={AccountLink} >{t('Deposit')}
				</MenuItem>
				<MenuItem onClick={onLogOut}>{t('Log Out')}</MenuItem>
			</Menu>
		</div >
	)
}
